<!-- src/components/TestHelper.vue -->
<template>
    <div>
      <h1 class="custom-h1">Page 2</h1>
      <!-- Your content for Page 1 goes here -->
      <h2 class="custom-h2"> function_1_3</h2>
      <FileUpload uniqueId="file-upload-3" function_name="function_1_3" v-bind:sample_choose="sampleChooseArr"></FileUpload>
      <h2 class="custom-h2"> function_1_4</h2>
      <FileUpload uniqueId="file-upload-4" function_name="function_1_4" v-bind:sample_choose="sampleChooseArr"></FileUpload>
      <h2 class="custom-h2"> function_1_5</h2>
      <FileUpload uniqueId="file-upload-5" function_name="function_1_5" v-bind:sample_choose="sampleChooseArr"></FileUpload>
    </div>
  </template>
  
  <script>
  import FileUpload from '@/components/FileUpload.vue';
  export default {
    components: {
      FileUpload,
    },
    name: 'TestHelper',
    data(){
      return {
        sampleChooseArr: ["UM", "AM1"]
      }
    }
  }
  </script>